import { render } from "./SearchModal.vue?vue&type=template&id=89c67bce"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=89c67bce&lang=css"
script.render = render

export default script